import Img from "next/image";
import React, { ReactElement } from "react";

import { ToTopButton } from "@/components/molecules/buttons/ToTopButton";

export default function Error500Page() {
  return (
    <div className="p-8 text-center md:p-24">
      <div className="m-auto w-[201px] h-[222px]">
        <Img src={`/customer/img/404-robot.svg`} width={201} height={222} alt="" />
      </div>
      <h1 className="mt-10 text-5xl font-medium md:text-7xl">
        <span>500</span>{" "}
        <span className="text-4xl md:text-5xl">Internal Server Error</span>
      </h1>
      <p className="mt-2 text-lg md:text-2xl">問題が発生しました。</p>
      <ToTopButton />
    </div>
  );
}

Error500Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
